import { useEffect, ReactNode, useState } from 'react';
///////////////////////////////////////////////////////////////////////////
import {
	// setActiveCollection,
	setNavigation,
	setStickerWonDialog,
} from '@/core/redux/slices';
import { useCustomDispatch, useCustomSelector } from '@/core/redux/hooks';
import { telegramWebApp } from '@/main';
import { GiftWon } from '@/app/shared/components';

type PageProps = {
	state?: string;
	children: ReactNode;
};

export const PageWrapper = ({ state, children }: PageProps) => {
	/*********************
	// #region Hooks
	**********************/
	const dispatch = useCustomDispatch();

	/*********************
	// #region Redux
	**********************/
	const { showStickerWonDialog } = useCustomSelector(
		(state) => state.collections
	);

	/*********************
	// #region States
	**********************/
	const [visibleDialogGiftWon, setVisibleDialogGiftWon] =
		useState<boolean>(false);

	/*********************
	// #region Constants
	**********************/
	const deviceHeight = telegramWebApp.viewportHeight;

	/*********************
	// #region Observables
	**********************/
	useEffect(() => {
		// if (state !== 'collections' && activeCollectionPosition !== null) {
		// 	dispatch(setActiveCollection(null));
		// }
		if (state) {
			dispatch(setNavigation(state));
		}
	}, [dispatch, state]);

	useEffect(() => {
		if (!showStickerWonDialog) return;
		setVisibleDialogGiftWon(true);
	}, [showStickerWonDialog]);

	/*********************
	// #region Functions
	**********************/
	const handleCloseDialog = () => {
		setVisibleDialogGiftWon(false);
		dispatch(setStickerWonDialog(false));
	};

	/*********************
	// #region Template
	**********************/

	return (
		<>
			<div
				style={{
					minHeight: `calc(${deviceHeight}px)`,
				}}
			>
				{children}
			</div>
			{visibleDialogGiftWon && process.env.VITE_ENABLE_COLLECTIONS && (
				<GiftWon
					isOpen={visibleDialogGiftWon}
					onClose={handleCloseDialog}
				/>
			)}
		</>
	);
};
